import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UserAuthService } from '../../../services/user-auth/user-auth.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  public loading: boolean;
  public signInEmail: string;
  public signInPassword: string;
  public activeUser: any;
  public showError: boolean = false;

  constructor(
    private _router: Router,
    private _userAuthService: UserAuthService
  ) {}

  ngOnInit() {}

  login() {
    if (this.signInEmail && this.signInPassword) {
      this.loading = true;
      this._userAuthService
        .signIn({ email: this.signInEmail, password: this.signInPassword })
        .then(result => {
          let auth: any;
          auth = result;
          console.log(auth);
          if (auth.message === 'Success' && auth.user.isAdmin) {
            sessionStorage.setItem('isAuthenticated', 'true');
            this._router.navigate(['/admin/promos']);
          } else {
            console.log('not sufficient permissions');
          }

          if (auth.message === 'Wrong Password') {
            // Some error handling
          } else if (auth.message === 'No User Found') {
            // Some error handling
          }
        });
      // this._afAuth.auth.signInWithEmailAndPassword(
      //   this.signInEmail,
      //   this.signInPassword
      // )
      // .then(success => {
      //   this._afAuth.authState.subscribe(user => {
      //     if(!user) {
      //       alert('Please log in!');
      //     } else {
      //       this.activeUser = user;
      //       this._router.navigate(['/admin/promos']);
      //     }
      //   })
      // });
    } else {
      this.showError = true;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/login/login/login.component.ts